import { render } from "./EditNotePage.vue?vue&type=template&id=078094b2&ts=true"
import script from "./EditNotePage.vue?vue&type=script&lang=ts"
export * from "./EditNotePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__